module.exports = __webpack_public_path__ + "img/authentication-selected.e91a8773.png";